<div class="container">
    <div class="d-flex align-items-center justify-content-between mb-4 pb-2 border-bottom">
        <h3 class="mb-0">Frequently Asked Questions</h3>
        <button class="btn btn-link text-decoration-none" (click)="toggle_collapse_all()"> <i class="fa-regular me-2" [ngClass]=" all_expanded ? 'fa-square-plus' : 'fa-square-minus' "></i>{{ all_expanded ? 'Expand' : 'Collapse' }} All</button>
    </div>

    <ol class="mb-4 pb-2 border-bottom">

        <li id="sdc-access-datasets" class="mb-3">
            <div class="d-flex align-items-center justify-content-between position-relative mb-2">
                <h6>How can I get access to the SDC Datasets?</h6>
                <a class="btn py-1 px-2 btn-sm btn-outline-secondary stretched-link" data-bs-toggle="collapse" href="#sdc-access-datasets-collapse" role="button" aria-expanded="false" aria-controls="collapseExample"> <i class="fa-solid fa-chevron-down"></i> </a>
            </div>
            <div class="collapse show" id="sdc-access-datasets-collapse">
                <div class="card card-body bg-light-subtle mb-4">
                    <p>Users can request access to the datasets that are available within the SDC platform as published / enabled by the SDC team or published by other users.</p>

                    <ol>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5">Once you are logged in, click on <b>SDC DATASETS</b> in the side menu. </div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-01-image-01.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Locate the <b>DATASETS</b> tab on side menu.</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5">Available datasets are listed, including a short description. Click on the <b>Request</b> button of the dataset you'd like access to.</div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-01-image-02.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Select "Request" of your desired dataset.</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5">The <b>SDC Data Access Request Form</b> will pop-up. Complete the form and click <b>Send Request</b>.</div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-01-image-03.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Complete the form and click <b>Send Request</b>.</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li>The request will be sent to the support team and access to the requested dataset will be given upon validation and approval of the information in the form.</li>
                    </ol>
                </div>
                <hr>
            </div>
        </li>


        <li id="sdc-launch-workstation" class="mb-3">
            <div class="d-flex align-items-center justify-content-between position-relative mb-2">
                <h6>How do I launch a workstation?</h6>
                <a class="btn py-1 px-2 btn-sm btn-outline-secondary stretched-link" data-bs-toggle="collapse" href="#sdc-launch-workstation-collapse" role="button" aria-expanded="false" aria-controls="collapseExample"> <i class="fa-solid fa-chevron-down"></i> </a>
            </div>
            <div class="collapse" id="sdc-launch-workstation-collapse">
                <div class="card card-body bg-light-subtle mb-4">

                    <p>Users can see their assigned workstations in the top section of the dashboard. By default, all workstations are in a stopped state.</p>

                    <ol>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5"> Click on the <b>Start</b> button to start your workstation machine. </div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-03-image-01.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Click on the start workstation button.</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5"> The workstation should become available within a few minutes, confirmed by the buttons changing color. Click on the <b>Connect</b> button to connect to the workstation.</div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-03-image-02.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Click the connect button.</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5">
                                    <p>The Guacamole landing page should be opened. Click the corresponding connection for your workstation. </p>
                                </div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-03-image-03.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Select your desired connection on the Guacamole landing page.</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5">
                                    <p>This opens the workstation login page. Enter your SDC username and password at the prompts to access your workstation desktop. </p>
                                    <p class="text-info-emphasis"><i><b>Note:</b> The workstation may take a few minutes to initialize before the login screen appears.</i></p>
                                </div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-03-image-04.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Login to the workstation.</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                    </ol>

                </div>
                <hr>
            </div>
        </li>

        <li id="sdc-upload-algorithm" class="mb-3">
            <div class="d-flex align-items-center justify-content-between position-relative mb-2">
                <h6>How do I upload my own data?</h6>
                <a class="btn py-1 px-2 btn-sm btn-outline-secondary stretched-link" data-bs-toggle="collapse" href="#sdc-upload-algorithm-collapse" role="button" aria-expanded="false" aria-controls="collapseExample"> <i class="fa-solid fa-chevron-down"></i> </a>
            </div>
            <div class="collapse" id="sdc-upload-algorithm-collapse">
                <div class="card card-body bg-light-subtle mb-4">
                    <p> Users who want to share data with other users from their project team can upload their own data to their assigned team/individual S3 buckets. </p>

                    <ol>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5">Click on <b>Upload</b> under the <b>My Data</b> section of the dashboard. </div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-04-image-01.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Click Upload</figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5"> A pop-up window appears prompting you to choose one or more files for upload to the assigned bucket. (The assigned bucket name will be displayed on the upload pop-up window.) Click <b>Upload</b> when satisfied.</div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-04-image-02.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center">Select files and destination in the pop up. </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-12">
                                    <p> Files that are uploaded from the web portal will be saved in the folder <b>username/uploaded_files</b>. </p>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-12">
                                    <p> To make these files available to members of the project team, users then need to move files from username/uploaded files to the project team S3 bucket using the CyberDuck tool. </p>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-12">
                                    <p> Users would be able to access only the files that are under the uploaded_files and export_requests folders. </p>
                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
                <hr>
            </div>
        </li>

        <li id="sdc-publish-algorithm" class="mb-3">
            <div class="d-flex align-items-center justify-content-between position-relative mb-2">
                <h6>How do I publish data for download?</h6>
                <a class="btn py-1 px-2 btn-sm btn-outline-secondary stretched-link" data-bs-toggle="collapse" href="#sdc-publish-algorithm-collapse" role="button" aria-expanded="false" aria-controls="collapseExample"> <i class="fa-solid fa-chevron-down"></i> </a>
            </div>
            <div class="collapse" id="sdc-publish-algorithm-collapse">
                <div class="card card-body bg-light-subtle mb-4">

                    <p>Follow the below steps to request files to download.</p>

                    <ol>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5"> In the <b>My Data</b> section of the dashboard, select the file you want to export. Click on the <b>Export</b> button if you are not approved to download the file.</div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-05-image-01.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center"> </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-5">
                                    <p>The pop-up window will have a form to fill out to request access:</p>
                                    <p><i>Note that the number of the <b>Data Provider</b> and <b>Sub-Dataset/Data Type</b> must match.</i></p>
                                </div>
                                <div class="col-7">
                                    <figure class="figure border rounded">
                                        <img src="/assets/images/faqs/dashboard/faq-05-image-02.png" class="figure-img img-fluid">
                                        <figcaption class="figure-caption text-center"> </figcaption>
                                    </figure>
                                </div>
                            </div>
                        </li>
                        <li class="mb-3">
                            <div class="row">
                                <div class="col-12">
                                    <p>When finished, click the <b>Submit Request</b> button and your request will be reviewed.</p>
                                </div>
                            </div>
                        </li>
                    </ol>
                </div>
            </div>
        </li>

    </ol>

    <h3>Helpful Links</h3>

    <ul>

        <li>
            <a href="https://securedatacommons.atlassian.net/wiki/spaces/DESK/pages/2223964161/RT+Guide+Researchers+User+Guide" target="_blank" rel="noopener noreferrer">Researcher User Guide</a>
            <p>Provides guidance on set-up and usage of the SDC web portal system for Research teams.</p>
        </li>

        <li>
            <a href="https://securedatacommons.atlassian.net/wiki/spaces/DESK/pages/1346273335/DP+Guides" target="_blank" rel="noopener noreferrer">Data Provider User Guide</a>
            <p>Provides guidance on set-up and usage of the SDC web portal system for Data Providers.</p>
        </li>

        <li>
            <a href="https://securedatacommons.atlassian.net/servicedesk/customer/portal/2" target="_blank" rel="noopener noreferrer">SDC Help Center: Service Desk Request</a>
            <p>Submit requests for additional data access, technical support or to report bugs via this Help Center resource.</p>
        </li>

        <li>
            <a href="https://www.transportation.gov/data/secure" target="_blank" rel="noopener noreferrer">Secure Data Commons (SDC) Microsite</a>
            <p>Provides overview of the SDC offerings for your team's project, data, or analysis efforts.</p>
        </li>

    </ul>
</div>


<!-- :: AUTH WARNING MODAL :: -->
<app-modal #AuthWarningModal [size]="'md'">
    <ng-container modal-header>
        <div class="d-flex align-items-center justify-content-start p-2">
            <h5 class="m-0">Session Expiration Warning</h5>
        </div>
    </ng-container>
    <ng-container modal-body>
        <div class="d-flex align-items-center justify-content-between p-2">
            <div>
                <p class="modal-text">Your session will expire soon, please refresh the page.</p>
            </div>
            <div>
                <button class="nav-item">
                    <a class="nav-link" href="/dashboard/faqs">Refresh</a>
                </button>
            </div>
        </div>
    </ng-container>
    <!-- <ng-container modal-footer> -->
    <!-- </ng-container> -->
</app-modal>
<!-- :: AUTH WARNING MODAL :: -->

<!-- :: AUTH EXPIRATION MODAL :: -->
<app-modal #AuthExpirationModal [size]="'md'">
    <ng-container modal-header>
        <div class="d-flex align-items-center justify-content-start p-2">
            <h5 class="m-0">Session Expired</h5>
        </div>
    </ng-container>
    <ng-container modal-body>
        <div class="d-flex align-items-center justify-content-between p-2">
            <div>
                <p class="modal-text">Your session has expired, please log back in.</p>
            </div>
            <div>
                <button class="nav-item">
                    <a class="nav-link" href="/">LOGIN</a>
                </button>
            </div>
        </div>
    </ng-container>
    <!-- <ng-container modal-footer> -->
    <!-- </ng-container> -->
</app-modal>
<!-- :: AUTH EXPIRATION MODAL :: -->